module.exports = __webpack_public_path__ + "img/zoll-emv.32558c06.png";